import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { jsonGet } from '../api';
import { Franchise } from '../models/franchise';


type SliceModel = Franchise;
const sliceName: string = 'franchises';

const currRequests: Set<ModelId> = new Set;

export const fetchFranchise = createAsyncThunk(
    sliceName + '/fetchById',
    async (id: ModelId) => {
        if (currRequests.has(id)) {
            return null;
        } else {
            currRequests.add(id);
            return await jsonGet<SliceModel>('/data/' + sliceName + '/' + id);
        }
    }
);

export const franchiseAdapter = createEntityAdapter<SliceModel>({
    selectId: (attrs: SliceModel) => attrs.id,
    sortComparer: (a, b) => a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase())
});
export const franchiseSlice = createSlice({
    name: sliceName,
    initialState: franchiseAdapter.getInitialState(),
    reducers: {
        addMany: franchiseAdapter.addMany,
        addOne: franchiseAdapter.addOne,
        updateMany: franchiseAdapter.updateMany,
        updateOne: franchiseAdapter.updateOne,
        upsertOne: franchiseAdapter.upsertOne,
        upsertMany: franchiseAdapter.upsertMany,
        removeOne: franchiseAdapter.removeOne
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder.addCase(fetchFranchise.fulfilled, (state, action) => {
            if (action.payload) {
                currRequests.delete(action.payload.id);
                franchiseAdapter.upsertOne(state, action.payload);
            }
        });
    },
});
